import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { addToast } from 'containers/Toasts/actions'

import {
  getPartnerSettingsError,
  getPartnerSettingsSuccess,
  updatePartnerSettingsError,
  updatePartnerSettingsSuccess,
} from './actions'
import { PARTNER_SETTINGS_GET_ASYNC, PARTNER_SETTINGS_UPDATE_ASYNC } from './constants'

const getPartnerSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(PARTNER_SETTINGS_GET_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .getPartnerSettings()
      .map((response) => getPartnerSettingsSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(getPartnerSettingsError, error)))
      .takeUntil(action$.ofType(PARTNER_SETTINGS_GET_ASYNC.CANCEL))
  )

const updatePartnerSettingsEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(PARTNER_SETTINGS_UPDATE_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .updatePartnerSettings(store.getState().settings.partnerSettings.data)
      .mergeMap(() =>
        Observable.of(
          updatePartnerSettingsSuccess(store.getState().settings.partnerSettings.data),
          addToast({ message: 'Settings was successfully updated' })
        )
      )
      .catch((error) => Observable.of(epicsErrorHandler(updatePartnerSettingsError, error)))
      .takeUntil(action$.ofType(PARTNER_SETTINGS_UPDATE_ASYNC.CANCEL))
  )

export default combineEpics(getPartnerSettingsEpic, updatePartnerSettingsEpic)
